/**
 * trackDialogButton — l'événement Amplitude du bouton d'une boîte, comme l'ancienne le mesure.
 *
 * Un seul type, `dialog.button.clicked`, avec le titre et le bouton en propriétés : `dialog_title`
 * et `button`, chacun ses 15 premiers caractères passés par `slugify`, les fragments qui
 * composaient le nom jusqu'ici (`dialog.button.clicked.<titre>.<bouton>`). Amplitude plafonne les
 * types d'un projet à 2 000 : un nom par libellé en avait consommé plus de 1 200 (P-4823). La
 * croix aussi : `button` vaut `times` (son ancien nom était `dialog.button.clicked.times`). Plus
 * aucun nom ne commence par `dialog.button.clicked.` : Amplitude peut bloquer ce préfixe, que les
 * versions de l'app d'avant continuent d'émettre.
 *
 * L'ancien espace pose ses boîtes par `DialogM` (`common/components/alert/dialog/Dialog.js`), qui
 * mesure par ceci ; un écran des ports qui remplace une boîte legacy l'appelle avec les mots de
 * l'ANCIENNE boîte, pour que la série continue sous les mêmes valeurs.
 *
 * Pur : aucun état, aucun hook.
 */
import slugify from "slugify"

import { track, type TrackedEvent } from "./trackEvent"

/** La croix d'une boîte legacy (`exitButton`). */
export const DIALOG_CLOSE = "times"

const DIALOG_BUTTON_EVENT = "dialog.button.clicked"

export function dialogButtonEvent(title: string | undefined, button: string): TrackedEvent {
    return {
        name: DIALOG_BUTTON_EVENT,
        properties: {
            dialog_title: slugify((title ?? "").substring(0, 15)),
            button: slugify(button.substring(0, 15)),
        },
    }
}

export function trackDialogButton(title: string | undefined, button: string): void {
    track(dialogButtonEvent(title, button))
}
